import { ButtonIcon, ConfirmationDialog } from '@statsbomb/kitbag-components';
import { styled } from 'styled-components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import themeHelper from '../../utils/themeHelper';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;
const StyledComments = styled.span`
  padding: ${themeHelper.spacing(0.25)};
`;

export function Comments({ comments, maxChars, videoKey }) {
  const intl = useIntl();
  const [displayConfirmation, setDisplayConfirmation] = useState(false);

  return (
    <>
      <Container>
        <StyledComments>{comments.substring(0, maxChars)}</StyledComments>
        <ButtonIcon
          disabled={comments.length < maxChars}
          icon="Expand"
          onClick={() => setDisplayConfirmation(true)}
          size="small"
          title={intl.formatMessage(
            {
              defaultMessage: 'See full comments for {videoKey}',
              id: 'cd57c',
            },
            {
              videoKey,
            },
          )}
          variant="secondary"
        />
      </Container>
      <ConfirmationDialog
        cancelLabel={null}
        confirmLabel={intl.formatMessage({
          defaultMessage: 'Close',
          id: 'd3d2e',
        })}
        id={`comment-${comments}`}
        isOpen={displayConfirmation}
        onConfirm={() => setDisplayConfirmation(false)}
        title={intl.formatMessage({
          defaultMessage: 'Comments',
          id: '8413c',
        })}
      >
        {comments}
      </ConfirmationDialog>
    </>
  );
}

Comments.propTypes = {
  comments: PropTypes.string,
  maxChars: PropTypes.number,
  videoKey: PropTypes.string.isRequired,
};
Comments.defaultProps = {
  comments: '',
  maxChars: 25,
};

export default { Comments };
